<template>
  <v-app primary>

    <v-layout row>
        <v-flex  xs9 class="text-xs-center"  >
          <img src="/static/back_connexion_archipro.png"  width="100%" height="100%" >

        </v-flex>

      <v-flex  xs3 class="mr-4 ml-4 mt-4 text-xs-center  " >
        <Loading :value="loading"></Loading>
        <v-container fluid grid-list-xl>
          <v-layout wrap  justify-space-between>
            <v-flex xs12>
              <div class="text-xs-center">
                <!--<img src="/static/gecer.png" alt="GECERPRO" class="mb-5" />-->
                <img :src="logo" alt="ARCHIPROV2"  width="50%" height="50%" class="mb-5" />
              </div>
              <v-card class="elevation-12">
                <v-card-text>
                  <v-form v-model="valid" ref="form" lazy-validation>
                    <v-text-field @keyup.13="submit" v-model="login" :rules="loginRules" prepend-icon="person" name="login" label="Login" type="text" required></v-text-field>
                    <v-text-field @keyup.13="submit" v-model="password" :rules="passwordRules" prepend-icon="lock" name="password" label="Mot de passe" id="password" type="password" required></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn block @click="submit" :disabled="!valid" color="primary" dark>Se connecter</v-btn>
                </v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="dialogPassword = true" flat small color="error">Mot de passe oublié</v-btn>
              </v-card>
            </v-flex>

            <v-flex xs12 class="align-content-end mt-5 mb-5" >

            </v-flex>

            <v-flex xs12 class="align-content-end mt-5" >
              <p style="font-weight:bold;" class="caption">&#174;
                <a href="https://www.archipro.ci/" target="_blank">ARCHIPRO 2017-2022</a>
                </p>
              <p class="primary--text">
                <a href="https://www.archipro.ci/" target="_blank">Conditions d'utilisation | confidentialité</a>
              </p>
            </v-flex>

          </v-layout>
        </v-container>


      </v-flex>
      <v-dialog
              attach="true"
              v-model="dialogPassword"
              width="500">
        <v-card>

          <v-toolbar dark color="primary">
            <v-toolbar-title> Reinitialisez votre mot de passe </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <p>Veuillez saisir votre nom d'utilisateur, vous recevrez un mot de passe par mail et sms </p>
            <p style="color:red">NB: Modifiez immediatement votre de passe lors de votre prochaine connexion</p>
          </v-card-text>

          <v-card-text>
            <v-form ref="form2" lazy-validation>
              <v-text-field v-model="login" :rules="loginRules" prepend-icon="person" name="login" label="Login" type="text" required></v-text-field>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="submitResetPassword()" :disabled="!isValidLogin" color="primary">Valider</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-app>
</template>


<script>
  import Loading from '@/components/Loading'
  let domaine = process.env.ROOT_API
  export default {
    components:{ Loading },
    data () {
      return {
        valid: true,
        password: '',
        dialogPassword: false,
        login: '',
        loading: false,
        loginRules: [
          (v) => !!v || 'Le login est obligatoire',
          (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
        ],
        passwordRules: [
          (v) => !!v || 'Le mot de passe est obligatoire',
          (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
        ],
        logo: process.env.LOGO
      }
    },
    methods: {
      submit () {
        const loading = this.$loading({
          lock: true,
          text: 'En cours de traitement',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.9)'
        })
        setTimeout(() => {
          loading.close()
        }, 3000)
        if (this.$refs.form.validate()) {
          let url = domaine + 'userCreate/login-user-connexion/' + this.login + '/' + this.password
          this.$http.get(url).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 5) {
                this.$notify({
                  title: 'BIENVENUE DANS VOTRE SESSION',
                  message: 'Connexion réussie avec succès.',
                  type: 'success',
                  position: 'top-center'
                })
                sessionStorage.setItem('sessionUser', true)
                let notif = response.body.data.notif
                let menu = response.body.data.menus
                let droit = response.body.data.roles
                let group = response.body.data.group
                sessionStorage.setItem('sessionNotif', JSON.stringify(notif))
                if(group.length > 0) {
                  sessionStorage.setItem('userGroup', JSON.stringify(group))
                }
                sessionStorage.setItem('sessionDomaine', JSON.stringify(domaine))
                sessionStorage.setItem('sessionAcces', JSON.stringify(menu)) //role pour acceder au menu
                sessionStorage.setItem('sessionDroit', JSON.stringify(droit)) //role pour acceder a certaines fonction
                sessionStorage.setItem('userInfo', JSON.stringify(response.body.data))
                this.$router.go({ name: 'Home' })
              } else if (verif.code === 4) {
                this.$notify.error({
                  title: 'ERREUR',
                  message: "Erreur d'indentification de l'utilisateur.",
                  position: 'top-center'
                })
              } else if (verif.code === 3) {
                this.$notify.error({
                  title: 'ERREUR',
                  message: "Erreur l'utilisateur inexistante pas.",
                  position: 'top-center'
                })
              } else if (verif.code === 2) {
                this.$notify.error({
                  title: 'ERREUR',
                  message: 'Le format de votre e-mail est invalide',
                  position: 'top-center'
                })
              }
            } else {
            }
          },
          response => {
          })
        }
      },
      submitResetPassword ()
      {
        this.loading = true
        this.dialogPassword = false

          let url = domaine + 'userCreate/reset/password'
          let data = new FormData()
          data.append("username", this.login)
          this.$http.post(url, data).then(response => {
            this.loading = false
            
                if (response.body.code == 0) {
                  this.$notify.error({
                    title: 'Reinitialisation du mot de passe',
                    message: "L'utilisateur n'exite pas"
                  });
                  return
                } else {
                  this.$notify({
                    type: 'success',
                    title: 'Reinitialisation du mot de passe',
                    message: "Le mot de passe a ete enregistre vous recevrez les identifiants par sms et mail"
                  });
                }

            }, response => {
            this.loading = false
            this.$notify.error({
              title: 'Reinitialisation du mot de passe',
              message: "Une erreur est survenu lors de la reinitialisation de votre mot de passe"
            });
          })

      },
      clear () {
        this.$refs.form.reset()
      }
    },
    computed: {
      isValidLogin () {
        if (this.login == undefined || this.login == "" ){
            return false
        }else{
          return true
        }
      }
    },
    mounted(){
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/Login.vue